export const DELETE_DOCUMENTS_REQUEST = 'DELETE_DOCUMENTS_REQUEST';

export const deleteDocumentsRequest = ( ids ) => ({
    type: DELETE_DOCUMENTS_REQUEST,
    payload: { ids }
});
